import React from 'react';
import {
  FaVimeoV,
  FaGlobe,
  // FaImdb,
  FaInstagram,
  FaFacebook,
  FaLinkedin,
  FaYoutube,
} from 'react-icons/fa';
import { FaImdb } from 'react-icons/fa6';

// Custom TikTok icon as SVG
const TikTok = props => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" fill="currentColor">
    <path d="M204.6 84.1a84.4 84.4 0 01-57.1-22.3v95.4a46 46 0 11-46-46v-32.4a84.1 84.1 0 00103.1 5.3z" />
  </svg>
);

const SocialLinks = ({ publicData }) => {
  const links = [
    { key: 'linkImdb', icon: <FaImdb />, label: 'IMDB' },
    { key: 'linkInstagram', icon: <FaInstagram />, label: 'Instagram' },
    { key: 'linkLinkedin', icon: <FaLinkedin />, label: 'LinkedIn' },
    { key: 'linkVimeo', icon: <FaVimeoV />, label: 'Vimeo' },
    { key: 'linkWebsite', icon: <FaGlobe />, label: 'Website' },
    { key: 'linkYoutube', icon: <FaYoutube />, label: 'YouTube' },
    { key: 'linkFacebook', icon: <FaFacebook />, label: 'Facebook' },
    { key: 'linkTikTok', icon: <TikTok width={24} height={24} />, label: 'TikTok' },
  ];

  return (
    <div style={{ display: 'flex', gap: '12px' }}>
      {links.map(({ key, icon, label }) => {
        const url = publicData?.[key];
        if (!url) return null;
        const fullUrl = url.startsWith('http') ? url : `https://${url}`;
        return (
          <a
            key={key}
            href={fullUrl}
            target="_blank"
            rel="noopener noreferrer"
            title={label}
            style={{ fontSize: '24px', color: '#000' }}
          >
            {icon}
          </a>
        );
      })}
    </div>
  );
};

export default SocialLinks;
